<template>
    <!-- Login Box -->
    <v-card flat tile>
        <!-- Login / Sign up Tab -->
        <div class="pt-6 text-center font-weight-regular grey--text text--darken-1">
            {{ isReqReset ? $langs.Auth.forgetPassword[$langs.lang] : $langs.Auth.chooseNewPassword[$langs.lang] }}
        </div>

        <!-- Reset Password Form -->
        <v-form ref="form" @submit.prevent="submit()" class="pt-4 pb-6 px-8" :disabled="disabled">
            <template v-if="isReqReset">
                <v-text-field
                    class="rounded-sm"
                    :label="$langs.Auth.email[$langs.lang]"
                    type="email"
                    v-model="account.email"
                    autocomplete="username"
                    :rules="[(v) => !!v || 'required']"
                    required
                ></v-text-field>
            </template>

            <template v-else>
                <input type="text" autocomplete="email" disabled style="display: none;" v-model="account.email">
                
                <!-- Password -->
                <v-text-field
                    class="rounded-sm"
                    :label="$langs.Auth.password[$langs.lang]"
                    :type="showField.password ? 'text' : 'password'"
                    v-model="account.password"
                    :append-icon="showField.password ? 'visibility' : 'visibility_off'"
                    @click:append="showField.password = !showField.password"
                    autocomplete="new-password"
                    :rules="rules.password"
                    required
                ></v-text-field>
                <!-- Confirm Password -->
                <v-text-field
                    class="rounded-sm"
                    :label="`${$langs.Gen.confirm[$langs.lang]}${$langs.space[$langs.lang]}${$langs.Auth.password[$langs.lang]}`"
                    type="password"
                    v-model="account.rePassword"
                    autocomplete="new-password"
                    :rules="rules.matchingPassword"
                    required
                ></v-text-field>
            </template>

            <v-btn
                block
                depressed
                large
                class="rounded-sm mt-2"
                type="submit"
                color="primary darken-1"
                :loading="isLoading"
                :disabled="disabled"
                >{{ $langs.Gen[ isReqReset ? 'confirm' : 'save' ][$langs.lang] }}</v-btn
            >
        </v-form>
    </v-card>
</template>

<script>
import api from "../../services/api";
import user from "../../services/user";

export default {
    props: ["toHome"],
    data() {
        return {
            account: {
                email: "",
                password: "",
                rePassword: "",
                token: ""
            },
            disabled: true,
            isLoading: false,
            showField: {
                password: false,
                rePassword: false,
            },
            rules: {
                password: [
                    (v) => !!v || "required",
                    (v) =>
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d|@#$%^&+=!\.`\-?*~(){}\[\]<>\\:;'"_]{8,}$/.test(v) || //(?=.*[A-Z])
                        "Minimum 8 characters, at least one lowercase letter, one uppercase letter and one number",
                ],
                matchingPassword: [
                    (v) => !!v || "required",
                    (v) =>
                        this.account.password == this.account.rePassword ||
                        "Password is not match",
                ],
            },
            isReqReset: true,
        };
    },
    mounted() {
        if (this.$route.query.t) {
            this.account.token = this.$route.query.t;
            this.isReqReset = false;
            this.validToken(this.account.token);
        } else {
            this.disabled = false;
        }
    },
    methods: {
        submit() {
            if (!this.$refs.form.validate()) return;
            if (this.isReqReset)
                return this.reqResetPwd();
            this.submitPassword();
        },
        async reqResetPwd() {
            let { email } = this.account;
            this.isLoading = true;
            let result = await user.reqResetPwd({ email });
            this.isLoading = false;
            if (result.success) {
                api.makeAlert("Please check your email!", "success");
                this.disabled = true;
            } else {
                api.makeAlert("Something went wrong, please try again", "error");
            }
        },
        async submitPassword() {
            let { password, token } = this.account;
            this.isLoading = true;
            let result = await user.updatePassword({ password, token });
            this.isLoading = false;
            if (!result.success) {
                return api.makeAlert(result.msg, "error");
            }
            api.makeAlert("Reset password successfully", "primary");
            this.disabled = true;
            setTimeout(() => {
                this.$router.push("/login");
            }, 3000);
        },
        async validToken(token) {
            let result = await user.updatePassword({ token }, { check: true });
            if (!result.success) {
                api.makeAlert("Your reset link may be invalid", "error");
                setTimeout(() => {
                    api.makeAlert("Please try again!", "secondary");
                    this.$router.push("/login");
                }, 2000);
                return;
            }
            this.account.email = result.email;
            this.disabled = false;
        },
    },
    metaInfo() {
        return {
            title: "Reset Password",
            titleTemplate: "%s · Marketpett",
            meta: [{ name: "robots", content: "noindex" }],
        };
    },
};
</script>

<style scoped lang="scss">
// .tab-active {
//     background: white;
//     &::before {
//         opacity: 0 !important;
//     }
// }
</style>